import { useState } from "react";
import { Alert, Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import { reserveBookIdentifier } from "services/books";

export default function BookIdentificationFields({ form, setForm, errors = {} }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const generate = async () => {
    setBusy(true);
    setError("");
    try {
      const { internalCode } = await reserveBookIdentifier(form.identifierRequestId);
      setForm((current) => ({ ...current, internalCode, publicationDetailsConfirmed: false }));
    } catch (failure) {
      setError(failure.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Box mb={3}>
      <Typography variant="subtitle2" mb={2}>
        Identificação da obra
      </Typography>
      <TextField
        fullWidth
        select
        label="Sua obra possui ISBN?"
        error={Boolean(errors.identificationMode)}
        data-validation-error={Boolean(errors.identificationMode)}
        helperText={errors.identificationMode}
        value={form.identificationMode}
        onChange={(event) =>
          setForm((current) => ({
            ...current,
            identificationMode: event.target.value,
            isbn: event.target.value === "pso" ? "" : current.isbn,
            classificationType: event.target.value === "pso" ? "BISAC" : current.classificationType,
            publicationDetailsConfirmed: false,
          }))
        }
      >
        <MenuItem value="pso">Não tenho ISBN — usar código PSO</MenuItem>
        <MenuItem value="isbn">Já tenho ISBN</MenuItem>
      </TextField>
      {form.identificationMode === "isbn" && (
        <TextField
          fullWidth
          sx={{ mt: 2 }}
          required
          label="ISBN da obra"
          value={form.isbn}
          inputProps={{ maxLength: 20 }}
          error={Boolean(errors.isbn)}
          data-validation-error={Boolean(errors.isbn)}
          helperText={errors.isbn || "Informe o ISBN já atribuído à obra. O PSO não emite ISBN."}
          onChange={(event) =>
            setForm((current) => ({
              ...current,
              isbn: event.target.value,
              publicationDetailsConfirmed: false,
            }))
          }
        />
      )}
      <Alert severity="info" sx={{ mt: 2, mb: 2 }}>
        O código PSO identifica esta obra nas publicações e nos pedidos para acompanhamento
        pós-venda. É uma referência interna: não substitui ISBN nem código de barras ou rastreio da
        transportadora.
      </Alert>
      <Box data-validation-error={Boolean(errors.internalCode)}>
        {errors.internalCode && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errors.internalCode}
          </Alert>
        )}
        {form.internalCode ? (
          <TextField
            fullWidth
            label="Código PSO da obra"
            value={form.internalCode}
            InputProps={{ readOnly: true }}
            helperText="Guarde este código. Ele permanece o mesmo ao tentar publicar novamente."
          />
        ) : (
          <Button variant="outlined" disabled={busy} onClick={generate}>
            {busy ? "Gerando código…" : "Gerar código PSO"}
          </Button>
        )}
      </Box>
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
}
